import script from "./VideoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoCard.vue?vue&type=script&setup=true&lang=js"

import "./VideoCard.vue?vue&type=style&index=0&id=75535dce&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75535dce"]])

export default __exports__